import { lookupCard } from "../../content/index.js";
import { playRevealedAction } from "../cards/playCard.js";
import { appendLog } from "../run/log.js";
import { accept, reject } from "../reducer/reject.js";
import type { GameState, RunState } from "../types/index.js";
import { continuePendingRepeat, withReshuffleLog } from "./completion.js";

type FieldJudgmentChoice = Extract<NonNullable<RunState["pendingChoice"]>, { kind: "fieldJudgment" }>;

function logMessage(cardId: string, result: "used-action" | "returned-action"): string {
  const cardName = lookupCard(cardId)?.name ?? "公開した施策";
  return result === "used-action"
    ? `現場判断で「${cardName}」を公開し、使用した。`
    : `現場判断で「${cardName}」を公開。山札の上に戻した。`;
}

export function resolveFieldJudgmentChoice(
  state: GameState,
  pending: FieldJudgmentChoice,
  selected: "use" | "return",
): GameState {
  if (!state.run?.activeCase) return reject(state, "プロジェクトが開始されていない");
  let run: RunState = { ...state.run, pendingChoice: null };
  let activeCase = state.run.activeCase;
  let reshuffled = false;
  if (selected === "use") {
    const result = playRevealedAction(run, activeCase, pending.revealed);
    reshuffled = result.reshuffled;
    activeCase = { ...result.activeCase, lastFieldJudgment: { cardId: pending.revealed.cardId, result: "used-action" } };
    run = { ...result.run, activeCase };
  } else {
    activeCase = { ...activeCase, lastFieldJudgment: { cardId: pending.revealed.cardId, result: "returned-action" } };
    run = { ...run, deck: [...run.deck, pending.revealed], activeCase };
  }
  const completed = withReshuffleLog(state.run, continuePendingRepeat(run), reshuffled);
  return accept({
    ...state,
    run: appendLog(completed, {
      phase: completed.activeCase?.phase ?? 0,
      kind: "action",
      message: logMessage(pending.revealed.cardId, selected === "use" ? "used-action" : "returned-action"),
    }),
  });
}
